var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-upload',{attrs:{"accept":_vm.accept,"custom-request":_vm.customRequest,"show-upload-list":_vm.showUploadList,"remove":_vm.remove,"disabled":_vm.disabled}},[_vm._t("default",null,null,{ loading: _vm.loading, preview: _vm.preview })],2)}
var staticRenderFns = []

export { render, staticRenderFns }